import { render, staticRenderFns } from "./AdminIndex.vue?vue&type=template&id=ee442bfe&"
import script from "./AdminIndex.vue?vue&type=script&lang=js&"
export * from "./AdminIndex.vue?vue&type=script&lang=js&"
import style0 from "./AdminIndex.vue?vue&type=style&index=0&id=ee442bfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports